import styled, { css } from 'styled-components'
import WorkspaceLogo from 'modules/workspace/components/WorkspaceLogo'

const badgeStyles = css`
  cursor: pointer;
  margin: 0 12px;
`

const StyledBadgeIcon = styled(WorkspaceLogo.Icon)`
  ${badgeStyles};
`

const StyledBadge = styled(WorkspaceLogo)`
  ${badgeStyles};
`

export { StyledBadge, StyledBadgeIcon }
